import { render, staticRenderFns } from "./WorkDetailCopy.vue?vue&type=template&id=7c5e1ae0&scoped=true"
import script from "./WorkDetailCopy.vue?vue&type=script&lang=js"
export * from "./WorkDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailCopy.vue?vue&type=style&index=0&id=7c5e1ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e1ae0",
  null
  
)

export default component.exports